import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Grid } from '@mui/material';
import './Footer.css';
import { translation } from 'utils/translate';
import { useSelector } from 'react-redux';

const Footer = () => {
  const lang = useSelector(
    (store) => store.lang,
  );

  const isThemePage =
    useLocation().pathname.includes('/teemat/');
  const isSaamePage = 
    useLocation().pathname.includes('/teemat/saamelaiset');

  return (
    <div 
      style={{ 
        marginTop: "10rem",
        padding: "2rem",
        fontWeight: "bold",
        backgroundColor: "#F4F5F5",
      }}
    >
      {isThemePage && (
        <Grid container sx={{ justifyContent: "center", alignItems: "center" }}>
          {isSaamePage?
          <p>
            Tämä teemanäkymä on luotu yhteistyössä <span style={{fontStyle: "italic"}}>MARCEN-tutkimushankkeen</span> kanssa
          </p>
          :
          <p>
            Tämä teemanäkymä on luotu yhteistyössä <span style={{fontStyle: "italic"}}>SILE-tutkimushankkeen</span> kanssa
          </p>
          }
        </Grid>
      )}
      <Grid container 
      sx={{ 
        lineHeight: "1.8rem",
        margin:"auto",
        maxWidth: "1480px",
      }}
      >
        <Grid item xs={12} sm={12} md={3} lg={3} sx={{marginRight: 10}}
        >
          <a
            href="https://www.utu.fi"
            target="_BLANK"
            rel="noopener noreferrer"
          >
            <img
              alt="Turun yliopiston logo"
              src="/utu-logo.png"
            />
          </a>
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={3} sx={{fontWeight: 700}}>
          {translation("footer","turun_yliopisto", lang)}
          <br />
          {translation("footer","oikeustieteellinen_tiedekunta", lang)}
          <br />
          {translation("footer","tutkimuksen_it", lang)}
        </Grid>
        <Grid item xs={12} sm={4} md={3} lg={3}>
          <div className="footer__link-wrapper">
            <Link to="/ohjeet" 
              style={{
                display: "block",
                color: "black",
                textDecoration: "underline",
                fontWeight: 700,
              }}
            >
              {translation("footer", "ohjeet", lang)}
            </Link>
            <Link to="/palaute" 
              style={{
                display: "block",
                color: "black",
                textDecoration: "underline",
                fontWeight: 700,
              }}
            >
              {translation("footer", "palaute", lang)}
            </Link>
            <Link to="/tietosuoja" 
              style={{
                display: "block",
                color: "black",
                textDecoration: "underline",
                fontWeight: 700,
              }}
            >
              {translation("footer", "tietosuoja", lang)}
            </Link>
            <Link
              to="/saavutettavuus"
              style={{
                display: "block",
                color: "black",
                textDecoration: "underline",
                fontWeight: 700,
              }}
            >
              {translation("footer", "saavutettavuus", lang)}
            </Link>
          </div>
        </Grid>
        <Grid container item xs={12} sm={4} md={2} lg={2} gap={1}>
          <a
            href="https://blogit.utu.fi/lakitutka/"
            target="_BLANK"
            rel="noopener noreferrer"
            style={{ width: "2em"}}
          >
            <img
              style={{  width: "2em"}}
              alt="Blog"
              src="/blog-solid.svg"
            />
          </a>
          <a
            href="https://www.instagram.com/lawpol_fi/"
            target="_BLANK"
            rel="noopener noreferrer"
            style={{ width: "2em"}}
          >
            <img
              style={{  width: "2em"}}
              alt="Instagram"
              src="/instagram.svg"
            />
          </a>
        </Grid>
      </Grid>
   </div>
  )
};

export default Footer;
